import type { AlphabetCardsData } from "@/entities/Activity/types/AlphabetCards";
import AlphabetCard from "./AlphabetCard";
import style from "./AlphabetCards.module.scss";

type Props = {
	details: AlphabetCardsData;
};

export const AlphabetCards: React.FC<Props> = ({ details }) => {
	const description = details.description;
	const data = details.data;
	return (
		<div className={style.alphabetCardsActivity}>
			<p>{description}</p>
			<div className={style.cardContainer}>
				{data.map((letterData) => (
					<AlphabetCard
						key={letterData.letter || letterData.transliteratedLetter}
						{...letterData}
					/>
				))}
			</div>
		</div>
	);
};
